module.exports = __webpack_public_path__ + "static/img/pingjie1.1a0c7ea4.png";